import { useModalDialogStore } from '~/stores/modalDialog'
export interface ISetShowModalDialog {
  callingMn: string
  title?: string | null
  subtitle?: string | null
  message?: string | null
  dialogStyle?: string | null
  doHideCancelButton?: boolean
  okShouldActLikeCancel?: boolean
  okButtonCaptionVerbOverride?: string | null
  cancelButtonCaptionVerbOverride?: string | null
  doSkipVerification?: boolean
  okButtonWidth?: number
  onOkCallback?: Function
  onOkCallbackData?: any
}

export async function setShowModalDialog(obj: ISetShowModalDialog) {
  const {
    callingMn,
    title,
    subtitle,
    message,
    dialogStyle,
    doHideCancelButton,
    okShouldActLikeCancel,
    okButtonCaptionVerbOverride,
    cancelButtonCaptionVerbOverride,
    doSkipVerification,
    okButtonWidth,
    onOkCallback,
    onOkCallbackData,
  } = obj

  const fn = `${callingMn} --> [cynqueModules/setShowModalDialog.ts] setShowModalDialog |`

  // Belt and suspenders - Clear everything.
  // Some or all properties may still be set after a broswer refresh.
  console.debug(`${fn} Clearing ModalDialog Store property...`)
  await useModalDialogStore().clearModalDialog()
  //

  // Set stuff

  if (title) {
    console.debug(`${fn}  Setting title to: ${title}`)
    await useModalDialogStore().setTitle(title)
  }

  if (subtitle) {
    console.debug(`${fn}  Setting subtitle to: ${subtitle}`)
    await useModalDialogStore().setSubtitle(subtitle)
  }

  if (message) {
    console.debug(`${fn}  Setting message to: ${message}`)
    await useModalDialogStore().setMessage(message)
  }

  if (dialogStyle) {
    console.debug(`${fn}  Setting dialogStyle to: ${dialogStyle}`)
    await useModalDialogStore().setDialogStyle(dialogStyle)
  }

  if (doHideCancelButton) {
    console.debug(
      `${fn}  Setting doHideCancelButton to: ${doHideCancelButton}]`
    )
    await useModalDialogStore().setDoShowCancelButton(doHideCancelButton)
  }

  if (okShouldActLikeCancel) {
    console.debug(
      `${fn}  Setting okShouldActLikeCancel to: ${okShouldActLikeCancel}]`
    )
    await useModalDialogStore().setOkShouldActLikeCancel(okShouldActLikeCancel)
  }

  if (okButtonCaptionVerbOverride) {
    console.debug(
      `${fn}  Setting okButtonCaptionVerbOverride to: ${okButtonCaptionVerbOverride}]`
    )
    await useModalDialogStore().setOkButtonCaptionVerbOverride(
      okButtonCaptionVerbOverride
    )
  }

  if (cancelButtonCaptionVerbOverride) {
    console.debug(
      `${fn}  Setting cancelButtonCaptionsOverride to: ${cancelButtonCaptionVerbOverride}]`
    )
    await useModalDialogStore().setCancelButtonCaptionsVerbOverride(
      cancelButtonCaptionVerbOverride
    )
  }

  if (doSkipVerification) {
    console.debug(
      `${fn}  Setting doSkipVerification to: ${doSkipVerification}]`
    )
    await useModalDialogStore().setDoSkipVerification(doSkipVerification)
  }

  if (okButtonWidth) {
    console.debug(`${fn}  Setting okButtonWidth to: ${okButtonWidth}]`)
    await useModalDialogStore().setOkButtonWidth(okButtonWidth)
  }

  if (onOkCallback) {
    console.debug(`${fn}  Setting onOkCallback to:`, onOkCallback)
    await useModalDialogStore().setOnOkCallback(onOkCallback)
  }

  if (onOkCallbackData) {
    console.debug(`${fn}  Setting onOkCallback to:`, onOkCallbackData)
    await useModalDialogStore().setOnOkCallbackData(onOkCallbackData)
  }

  // All done setting stuff. Show the dialog.
  console.debug(`${fn}  Setting showModalDialog to: true`)
  await useModalDialogStore().setShowModalDialog(true)
}
